export default __webpack_public_path__ + "static/media/instructor-pic.707e6802.JPG";